import React, { createContext, useCallback, useContext, useState } from 'react';

const CapabilitiesStateContext = createContext({});
const CapabilitiesDispatchContext = createContext(() => {});

export function CapabilitiesProvider({ children, defaultCapabilities = {} }) {
  const [capabilities, setCapabilities] = useState(defaultCapabilities);

  const updateCapabilities = useCallback((pageOverrides = {}) => {
    setCapabilities({ ...defaultCapabilities, ...pageOverrides });
  }, [defaultCapabilities]);

  return (
    <CapabilitiesStateContext.Provider value={capabilities}>
      <CapabilitiesDispatchContext.Provider value={updateCapabilities}>
        {children}
      </CapabilitiesDispatchContext.Provider>
    </CapabilitiesStateContext.Provider>
  );
}

export function useCapabilities() {
  return useContext(CapabilitiesStateContext);
}

export function useSetCapabilities() {
  return useContext(CapabilitiesDispatchContext);
}
